"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLinkable = exports.filterAndAssembleArtifactList = exports.artifactsForDisplay = void 0;
var FeatureSources;
(function (FeatureSources) {
    FeatureSources["NOTE"] = "raw_body";
    FeatureSources["BODY_REGION"] = "body_region";
    FeatureSources["PROCEDURE_TYPE"] = "procedure_type";
    FeatureSources["PROCEDURE_CATEGORY"] = "procedure_category";
    FeatureSources["EXAM_DESCRIPTION"] = "exam_description";
    FeatureSources["EXAM_TYPE"] = "exam_type";
    FeatureSources["REASON_FOR_VISIT"] = "reason_for_visit";
    FeatureSources["WORK_QUEUE_NAME"] = "work_queue_name";
})(FeatureSources || (FeatureSources = {}));
// as more types become linkable, we can add them here.
var linkableEvidenceTypes = new Set([
    FeatureSources.NOTE,
    FeatureSources.REASON_FOR_VISIT,
    FeatureSources.PROCEDURE_TYPE,
    FeatureSources.EXAM_DESCRIPTION
    // FeatureSources.EXAM_TYPE,
    // FeatureSources.BODY_REGION,
    // FeatureSources.PROCEDURE_CATEGORY
]);
// ----------------------------------
// sort
// ----------------------------------
var sortValues = {
    CODED: 5,
    SUBMITTED: 10,
    PROCESSED: 20,
    ASSEMBLED: 30,
    MAPPED: 40,
    PREDICTION: 50,
    REFERRAL: 60,
    REMITTANCE: 70,
    CLINICAL: 100,
    CLAIM: 110
};
var MAX_VAL = 1000;
var comparator = function (artifactA, artifactB) {
    var valA = sortValues[artifactA.type] || MAX_VAL;
    var valB = sortValues[artifactB.type] || MAX_VAL;
    if (valA < valB) {
        return -1;
    }
    if (valA > valB) {
        return 1;
    }
    // a must be equal to b
    return 0;
};
// ----------------------------------
// displayable
// ----------------------------------
var isDisplayable = function (artifactSet, artifact) { return artifactSet.has(artifact.type); };
var artifactsForDisplay = function (artifactList, artifactSet) {
    var filtered = artifactList.filter(function (artifact) {
        return isDisplayable(artifactSet, artifact);
    });
    var sorted = filtered.sort(comparator);
    return sorted;
};
exports.artifactsForDisplay = artifactsForDisplay;
var OWN_META = {
    imported: false,
    ownerCaseId: null,
    description: "These codes originated in your system"
};
var LINKED_META = {
    imported: true,
    ownerCaseId: null,
    description: "These codes come from a different case"
};
var filterAndAssembleArtifactList = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var caseRun = _a.caseRun, artifactSet = _a.artifactSet, importedCaseRun = _a.importedCaseRun, importedSet = _a.importedSet;
    var artifacts = (0, exports.artifactsForDisplay)((_b = caseRun.artifacts) !== null && _b !== void 0 ? _b : [], artifactSet).flat();
    var own = artifacts.map(function (artifact) { return (__assign(__assign({}, artifact), { meta: __assign({}, OWN_META) })); });
    if (importedCaseRun && importedSet) {
        var alternates = (0, exports.artifactsForDisplay)((_c = importedCaseRun === null || importedCaseRun === void 0 ? void 0 : importedCaseRun.artifacts) !== null && _c !== void 0 ? _c : [], importedSet).flat();
        var meta_1 = __assign(__assign({}, LINKED_META), { ownerCaseId: importedCaseRun.case_id, description: "".concat(importedCaseRun.exam_description, " - Acc #: ").concat((_e = (_d = importedCaseRun.primary_clinical_identifier) === null || _d === void 0 ? void 0 : _d.number) !== null && _e !== void 0 ? _e : "N/A", " (").concat((_g = (_f = importedCaseRun.primary_clinical_identifier) === null || _f === void 0 ? void 0 : _f.issuer) !== null && _g !== void 0 ? _g : "N/A", ")") });
        var linked = alternates
            .map(function (artifact) { return (__assign(__assign({}, artifact), { meta: meta_1 })); })
            .flat();
        return __spreadArray(__spreadArray([], __read(own), false), __read(linked), false);
    }
    return __spreadArray([], __read(own), false);
};
exports.filterAndAssembleArtifactList = filterAndAssembleArtifactList;
// ----------------------------------
// linkable
// ----------------------------------
var isLinkable = function (evidenceKey) {
    return linkableEvidenceTypes.has(evidenceKey);
};
exports.isLinkable = isLinkable;
//# sourceMappingURL=artifact-utils.js.map